function initBody() {
    $('body')
        .on('click', function() {
            $('.tooltip.in').remove();
        })
        .on('show.bs.tooltip', '[data-toggle="tooltip"]', function(e) {
            $('[data-toggle="tooltip"]')
                .not($(e.currentTarget)).tooltip('hide');
        })
        .on('show.bs.modal', '.modal.in', function() {
            $('.tooltip.in').remove();
        })
        .on('hide.bs.modal', '.modal.in', function() {
            $('.tooltip.in').remove();
        });
}

function init(view) {
    view.$('[data-toggle="tooltip"][data-delayed]').tooltip({
        delay: {show: 1000, hide: 0}, trigger: 'hover'
    });
    view.$('[data-toggle="tooltip"]').tooltip({
        trigger: 'manual'
    });

    let timeoutId;
    view.$('[data-toggle="tooltip"]').hover(
        function() {
            view.$(this).tooltip('show');
        },
        function() {
            let delay = view.$(this).data('delay') || 4000;
            timeoutId = setTimeout(() => {
                view.$(this).tooltip('hide');
            }, delay);
        }
    );
}

module.exports = {
    initBody: initBody,
    init: init
};



// WEBPACK FOOTER //
// ./app/helpers/tooltip.js